import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapSeparation extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapSeparationOpened: false
       }
    }

    getSeparationDisplayValue = (separation) => {
        let mappedSeparation = this.props.mapOptions.filter(option => option.label === separation.label);
        if (mappedSeparation.length > 0)
            return mappedSeparation[0].label;
        else
            return '';
    }

    render() {
        let { allSeparationMapping } = this.props.mapSeparation;
        let {isMapSeparationOpened} = this.state;
        let noOfSeparationTypesMapped = allSeparationMapping.filter(separationMapping => separationMapping.column!=="").length;
        
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfSeparationTypesMapped} of {allSeparationMapping.length} values to separation categories</Col>
                <Col sm="1" md="1" className={isMapSeparationOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapSeparationOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapSeparationOpened: !isMapSeparationOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapSeparationOpened}>
                 <div className="mt30 mapped-review-records">
                   {allSeparationMapping.map((mappedSeparation, index) => {
                        return (<div key={index+mappedSeparation.value} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                                {!mappedSeparation.value || mappedSeparation.value===undefined||mappedSeparation.value===null ||mappedSeparation.value==="null"|| mappedSeparation.value==="undefined"? 
                                mappedSeparation.value="empty"
                                :
                                mappedSeparation.value
                                } Separation Types
                            </span>
                             {mappedSeparation.column!=="" ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getSeparationDisplayValue(mappedSeparation.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
